
function GoogleMapStyle() {

	return new google.maps.StyledMapType(
		[
			{
    			"featureType": "landscape.man_made",
    			"elementType": "geometry.fill",
    			"stylers": [
					{
            			"color": "#e5e2d5"
					}
    			]
			},
			{
    			"featureType": "landscape.natural.terrain",
    			"elementType": "geometry.fill",
    			"stylers": [
					{
            			"color": "#f3efe7"
					}
    			]
			},
			{
    			"featureType": "poi",
    			"elementType": "geometry.fill",
    			"stylers": [
					{
            			"color": "#d3eddd"
					}
    			]
			},
			{
    			"featureType": "road.highway",
    			"elementType": "geometry.fill",
    			"stylers": [
					{
            			"color": "#f0ebdd"
					}
    			]
			},
			{
    			"featureType": "road.highway",
    			"elementType": "geometry.stroke",
    			"stylers": [
					{
            			"color": "#f0ebdd"
					}
    			]
			},
			{
    			"featureType": "road.highway",
    			"elementType": "labels.icon",
    			"stylers": [
					{
            			"saturation": "-53"
					},
					{
            			"lightness": "-15"
					}
    			]
			},
			{
    			"featureType": "road.arterial",
    			"elementType": "geometry.fill",
    			"stylers": [
					{
            			"color": "#ffffff"
					}
    			]
			},
			{
    			"featureType": "road.local",
    			"elementType": "geometry.fill",
    			"stylers": [
					{
            			"color": "#ffffff"
					}
    			]
			},
			{
    			"featureType": "water",
    			"elementType": "geometry.fill",
    			"stylers": [
					{
            			"color": "#c9e2ff"
					}
    			]
			},
			{
    			"featureType": "water",
    			"elementType": "labels.text.fill",
    			"stylers": [
					{
            			"color": "#5378a9"
					}
    			]
			}
		],
        { name: 'The Victoria Style' });
	}